import socketService from '@services/socket.service';

/**
 * Mirrors the socket service's derived state into Vuex.
 *
 * A Vuex plugin receives the store as an argument, so this file imports nothing
 * from `@/store` and creates no cycle — which is why the service itself stays
 * free of any store dependency.
 *
 * The service owns connection and subscription state; this is the only place
 * that copies it across, and components read it through getters rather than
 * calling the service.
 */
export default function socketPlugin(store) {
    socketService.onStatus(status => {
        store.commit('SET_SOCKET_STATUS', status);

        // Presence is meaningless while the socket is down, and the roster
        // would otherwise still show whoever was there when it dropped.
        // `here()` delivers an authoritative list on resubscribe.
        if (status !== 'connected') {
            store.commit('CLEAR_CHANNEL_USERS');
        }
    });

    socketService.onSubscriptionChange(names => {
        store.commit('SET_SUBSCRIBED_CHANNELS', names);
    });
}
